import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';
import { useNavigate, useParams } from 'react-router';
import React from 'react';
import { FinancialItemDataDynamicForm } from 'src/financial/financial-data/financial-item/FinancialItemDataDynamicForm';
import { Client } from 'src/users';
import { useFlags } from 'src/feature-flags/FlagsHook';

type Params = {
  product: string;
};

export default function CreateFinancialItemPage() {
  const { product } = useParams<Params>();
  const { client } = useCurrentClientIfAvailable();

  if (product && client) {
    return <CreateFinancialItem product={product} client={client} />;
  }
}

type Props = {
  product: string;
  client: Client;
};

function CreateFinancialItem({ product, client }: Props) {
  const navigate = useNavigate();
  const { flagEnabledNewLayout } = useFlags();

  const handleSave = (id: string) => {
    navigate(`/client/${client.id}/financial-items/${product}/${id}`);
  };

  const backHref = flagEnabledNewLayout ? `/client/${client.id}/financial-data/create` : undefined;

  return (
    <FinancialItemDataDynamicForm
      product={product}
      client={client}
      onSuccessfulSave={handleSave}
      backHref={backHref}
    />
  );
}
